import styled from '@emotion/styled';
import { KizenTypography } from '__app/typography';
import Icon from '__components/Kizen/Icon';
import IconButton from '__components/Kizen/IconButton';
import SubNavigation from '__components/Navigation/SubNavigation';
import { richTextStyle } from 'components/WYSIWYG/MarkdownEditor/styles';

export const StyledSubNavWrapper = styled.div`
  position: relative;
  margin: 0 auto;
`;

export const StyledSubNavigation = styled(SubNavigation)`
  && a {
    padding-bottom: 10px !important;
  }
`;

export const NavWrapper = styled.div`
  position: relative;
  margin: 0 auto;
`;

export const StyledMarkdownContent = styled.div`
  font-size: 14px;
  ${richTextStyle}
  & img {
    display: block;
    max-width: 100px;
    height: auto;
  }
`;

export const StyledQuickFiltersLayout = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 15px;
  margin: 15px 0;
  border-bottom: 1px solid var(--color-border-medium-light);
  min-height: 42px;
`;

export const StyledQuickFiltersHeading = styled(KizenTypography)`
  font-size: 12px;
  text-transform: uppercase;
`;

export const StyledActionButton = styled(IconButton)`
  width: 12px;
  height: 12px;
`;

export const StyledIcon = styled(Icon)`
  cursor: pointer;
  & > svg {
    height: initial;
    width: 12px;
  }
`;
